import { queryOptions, useQuery } from '@tanstack/react-query';
import { AdaptivePlannerVirtualResourcesApi } from '@/lib/api/adaptive-planner/virtual-resources';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getVirtualResourcesQueryOptions = ({
  planId,
  enabled,
}: {
  planId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.virtualResources.planVirtualResources({ planId }),
    queryFn: () =>
      AdaptivePlannerVirtualResourcesApi.getVirtualResources({
        planId,
      }),
    enabled: enabled && !!planId,
  });

export const useGetVirtualResourcesQuery = ({
  planId,
  enabled = true,
}: {
  planId: number;
  enabled?: boolean;
}) => {
  return useQuery(getVirtualResourcesQueryOptions({ planId, enabled }));
};
